<template>
    <b-button @click.stop="emitClickEvent" :block="block" :disabled="disabled || loading" :class="buttonClass">
        <div v-if="!loading" class="d-flex justify-content-center align-items-center h-100 w-100 info-container">
            <icon class="left-icon" v-if="leftIcon && leftIcon.name" :color="leftIcon.color" :name="leftIcon.name" :scale="leftIcon.scale" />

            <span>{{ text }}</span>

            <icon class="right-icon" v-if="rightIcon && rightIcon.name" :color="rightIcon.color" :name="rightIcon.name" :scale="rightIcon.scale" />

            <icon class="center-icon" v-if="centerIcon && centerIcon.name" :color="centerIcon.color" :name="centerIcon.name" :scale="centerIcon.scale" />
        </div>
        <b-spinner v-else small variant="light" :loading="true" />
        <slot name="dropdown"> </slot>
    </b-button>
</template>

<script>
/**
 * Summary.
 * Use this component to mount a CIN default button.
 *
 * @param {String} text - Text value of the button.
 * @param {String} type - Possible values: red | blue | yellow | black | white | gray | primary-1 | primary-2 | primary-3 | primary-4 | secondary-1 | link.
 * @param {String} borderType - Possibles values: gray.
 * @param {String} borderType - Possible values: gray.
 *
 * @param {Boolean} upperCase - if the text should be all in upper case
 * @param {Boolean} lowerCase - if the text should be all in lower case
 * @param {Boolean} normalCase - Use the text as it is
 * @param {Boolean} capitalCase - If the text in the button is in capital case.
 * @param {Boolean} disabled - If the button is disabled.
 * @param {Boolean} loading - Controls when to shows a loading indicator inside the button.
 * @param {Boolean} block - The button will use all available width
 * @param {Boolean} fitInput - Set the top and bottom left corners-radius to 0.
 * @param {Boolean} pill - Uses the pill button style.
 * @param {Boolean} noRadius - Disable button border-radius.
 * @param {Boolean} small- Renders a smaller button height.
 *
 * @param {Object} centerIcon - The center icon Object containing name and scale. (For buttons that only show an icon)
 * @param {Object} leftIcon - The left icon Object containing name and scale.
 * @param {Object} rightIcon - The right icon Object containing name and scale.
 *
 * @event click - On button click.
 */

export default {
    name: 'CustomButton',
    props: {
        text: String,
        type: {
            type: String,
            default: 'blue',
        },
        borderType: {
            type: String,
            default: '',
        },

        upperCase: Boolean,
        lowerCase: Boolean,
        normalCase: Boolean,
        capitalCase: Boolean,
        normalCase: Boolean,
        disabled: Boolean,
        loading: Boolean,
        block: Boolean,
        fitInput: Boolean,
        pill: Boolean,
        noRadius: Boolean,
        small: Boolean,

        leftIcon: Object,
        rightIcon: Object,
        centerIcon: Object,
    },
    computed: {
        /**
         * Summary.
         * Use this computed property to get the correct button classes.
         *
         * @returns {Array}
         */
        buttonClass: function () {
            let classes = ['cin-button', this.type, this.borderType]

            if (this.fitInput) {
                classes.push('join')
            }

            if (this.capitalCase) {
                classes.push('capital-case')
            }

            if (this.normalCase) {
                classes.push('normal-case')
            }

            if (this.upperCase) {
                classes.push('upper-case')
            }

            if (this.lowerCase) {
                classes.push('lower-case')
            }

            if (this.pill) {
                classes.push('pill')
            }

            if (this.noRadius) {
                classes.push('no-radius')
            }

            if (this.small) {
                classes.push('small')
            }

            return classes
        },
    },
    methods: {
        /**
         * Summary.
         * Use this method to emit a new button click.
         *
         * @param {Object} event - The click event object.
         */
        emitClickEvent(event) {
            this.$emit('click', event)
        },
    },
}
</script>
<style lang="scss" scoped>
@import '@/scss/components/Utils/custom-button.scss';
</style>
